import script from "./WebhooksConnectionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhooksConnectionSettings.vue?vue&type=script&setup=true&lang=js"

import "./WebhooksConnectionSettings.vue?vue&type=style&index=0&id=ef77d5d6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef77d5d6"]])

export default __exports__